import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import User from "../components/user/Profile";
import RenderMusicList from "../components/user/RenderList";
import { musicService, userService } from "../services";
import ErrorModal from "../components/UI/Error";
import Spinner from "../components/UI/Spinner";

const FanPage = () => {
  const { profileName } = useParams();
  const [artist, setArtist] = useState(null);
  const [tracks, setTracks] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    const fetchArtist = async () => {
      try {
        setError(false);
        const [artiste, music]= await Promise.all([
           userService.myProfileFanPage(profileName),
           musicService.myRecentMusic(profileName),
        ]) 
        setArtist(artiste);
        setTracks(music);
      } catch (error) {
        setError(true);
        console.log("Error now");
      } finally {
        setLoading(false);
      }
    };

    fetchArtist();
  }, [profileName]);

  const closeErrorModal = () => setError(false);

  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );
    console.log(errorMessage);
    
  if (artist?.error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={closeErrorModal}
        title={"Error Getting Artiste"}
        message={
          `${errorMessage
            ||
          "There is error while trying to fetch the artiste details. Please check your internet contivities and refresh this page to try again or ensure you are with correct artiste's fangape address"}`
        }
      />
    );
  return (
    <User user={artist} privateMode={artist?.privacyMode || false}>
      <RenderMusicList
        tracks={tracks}
        title="My Recent Music"
        url={`/fanpage/${artist.username}`}
      />
    </User>
  );
};

export default FanPage;
